import type { LandingSearchFormFilters } from '@rover/react-lib/src/pages/landing/components/LandingSearchForm';
import { AgeEnum } from '@rover/rsdk/src/apiClient/latest/model/ageEnum';
import type { LocalizedBrandService } from '@rover/rsdk/src/apiClient/latest/model/localizedBrandService';
import { PetTypeEnum } from '@rover/rsdk/src/apiClient/latest/model/petTypeEnum';
import { PetType } from '@rover/types/src/Pet';
import type { ServiceTypeSlug } from '@rover/types/src/ServiceType';

/**
 * What this page searches for, read off its LocalizedServiceKeyword payload. Prefers
 * `searchParams`, the backend-computed payload `getServiceLandingSearchQueryOptions` searched with,
 * so every link matches the carousel's results and carries its pet counts (e.g. cat-boarding's
 * catCount), without which pricing on the search page defaults to one dog. `location` stays blank,
 * so search resolves the visitor's location the same way the carousel's search did.
 */
export const getServiceLandingSearchFilters = ({
  internalServiceType,
  petDetails,
  petType,
  searchParams,
}: LocalizedBrandService): LandingSearchFormFilters => {
  // Matches LocalizedServiceKeyword.search_params, which sets puppy only for an adolescent dog.
  const isPuppy = petType === PetTypeEnum.dog && petDetails.age === AgeEnum.adolescent;

  // Pulls named fields rather than spreading `searchParams`, whose singular `petType` would
  // clobber the `PetType[]` the form's service-type options filter on.
  return {
    serviceType: (searchParams?.serviceType ?? internalServiceType.slug) as ServiceTypeSlug,
    petType: [petType === PetTypeEnum.cat ? PetType.CAT : PetType.DOG],
    location: '',
    dogCount: searchParams?.dogCount,
    catCount: searchParams?.catCount,
    puppyCount: searchParams?.puppyCount,
    puppy: searchParams?.puppy ?? (isPuppy || undefined),
  };
};
